import { FC, useCallback, useState } from "react";
import { StyleProp, StyleSheet, Text, TextStyle, View } from "react-native";
import { kStyleConst } from "src/kStyle";
import { Radio_Button } from "./impComponents";

interface tRadioProps {
  selectedIndex?: number;
  myOptions: Array<string>;
  myFlow?: "row" | "column";
  labelTextStyle?: StyleProp<TextStyle>;
  onSelect?: ({ myValue, myIndex }: { myValue: string; myIndex: number }) => void;
  editable?: boolean;
}

const Radio: FC<tRadioProps> = ({
  selectedIndex = -1,
  myOptions,
  myFlow = "column",
  labelTextStyle,
  onSelect,
  editable,
}) => {
  const [sSelectedIndex, _setSelectedIndex] = useState<number>(selectedIndex);
  const _handleSelect = useCallback(
    (myIndex: number) => {
      _setSelectedIndex(myIndex);
      if (onSelect) onSelect({ myValue: myOptions[myIndex], myIndex: myIndex });
    },
    [myOptions, onSelect],
  );
  return (
    <View style={myFlow === "row" ? styles.checkGroupContainerRow : styles.checkGroupContainer}>
      {myOptions.map((myOption, myIndex) => (
        <RenderOption
          key={myOption}
          myOption={myOption}
          myIndex={myIndex}
          _setSelectedIndex={_handleSelect}
          labelTextStyle={labelTextStyle}
          sSelectedIndex={sSelectedIndex}
          editable={editable}
        />
      ))}
    </View>
  );
};

type tRenderOptionProps = {
  myOption: string;
  _setSelectedIndex: (myIndex: number) => void;
  myIndex: number;
  labelTextStyle: StyleProp<TextStyle>;
  sSelectedIndex: number;
  editable?: boolean;
};

const RenderOption: FC<tRenderOptionProps> = ({
  myOption,
  _setSelectedIndex,
  myIndex,
  labelTextStyle,
  sSelectedIndex,
  editable = true,
}) => {
  const _handleSelect = useCallback(() => {
    if (editable) {
      _setSelectedIndex(myIndex);
    }
  }, [_setSelectedIndex, editable, myIndex]);
  return (
    <View key={myOption} style={styles.P08_01_CheckboxContainer}>
      <View style={styles.RadioIconContainer}>
        <Radio_Button
          style={styles.RadioIcon}
          button={{ onPress: _handleSelect }}
          state={sSelectedIndex === myIndex ? "on" : "off"}
        />
      </View>
      <Text onPress={_handleSelect} style={[styles.checkboxLabel, labelTextStyle]}>
        {myOption}
      </Text>
    </View>
  );
};

export default Radio;

const styles = StyleSheet.create({
  P08_01_CheckboxContainer: {
    alignItems: "center",
    flexDirection: "row",
    marginBottom: 2 * kStyleConst.kSpacing,
    marginTop: kStyleConst.kSpacing,
  },
  RadioIcon: {
    height: kStyleConst.kRadioButton,
  },
  RadioIconContainer: {
    alignItems: "flex-start",
    alignSelf: "center",
    justifyContent: "center",
  },
  checkGroupContainer: {
    alignItems: "flex-start",
    flexDirection: "column",
  },
  checkGroupContainerRow: {
    flexDirection: "row",
  },
  checkboxLabel: {
    marginLeft: 8,
    marginRight: 16,
  },
});
